import { PROFILE_ERROR, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG ,GET_PROFILE_DETAIL,GET_PROFILE_DETAIL_SUCCESS,
  GET_COUNTRIES,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILED,
  GET_STATE,
  GET_STATE_SUCCESS,
  GET_STATE_FAILED,
  VALIDATE_URL,
  VALIDATE_URL_SUCCESS,
  VALIDATE_URL_FAILED,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILED,
  GET_STATE2,
  ACCOUNT_SWITCH,
  ACCOUNT_SWITCH_SUCCESS,
  ACCOUNT_SWITCH_FAILED,
  ACCOUNT_SWITCH_CLEAR
} from "./actionTypes"

const initialState = {
  error: "",
  success: "",
  loading: false,
  countriesData:null,
  statesBasedOnCountry:null,
  isUrlValid:null ,
  isUrlValidFailed:null,
  editSuccess:null,
  editFailed:null,
  loader:false,
  grantedUserType:null,
  requestedUserType:null,
  accountSwitchError:null
}

const profile = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_PROFILE:
      state = { ...state ,editFailed:null,loader:true}
      break
      case EDIT_PROFILE_SUCCESS:
        state = { ...state ,loader: false,editSuccess:action.payload,editFailed:null}
        break
        
        case EDIT_PROFILE_FAILED:
          state = { ...state ,loader: false,editSuccess:null,editFailed:action.payload}
          break  
      case GET_PROFILE_DETAIL:
      state={...state,
        loader: true,}
      break
      case GET_PROFILE_DETAIL_SUCCESS:
        state={...state,
          loader: false,
          success:action.payload}
        break;
    case PROFILE_SUCCESS:
      state = { ...state, 
        loading: false,
        success: action.payload,
      error:null }
      break
    case PROFILE_ERROR:
      state = { ...state, 
        loading: false,
        success:null,
        error: action.payload }
      break
    case RESET_PROFILE_FLAG :
      state = { ...state,
        loading: false,
         success: null }
      break
      case GET_COUNTRIES :
      state = { 
        ...state, 
        loading: true,
         }
      break
      case GET_COUNTRIES_SUCCESS :
      state = { 
        ...state, 
        countriesData: action.payload.user,
        loading: false
       }
      break
      case GET_COUNTRIES_FAILED :
      state = { 
        ...state, 
        countriesData: null ,
        loading: false
      }
      break
    case GET_STATE :
      state = { 
        ...state, 
        loading: true
         }
      break
      case GET_STATE2 :
        state = { 
          ...state, 
          loading: true
           }
        break
      case GET_STATE_SUCCESS :
        state = { 
          ...state, 
          statesBasedOnCountry: action.payload.user,
          loading: false
         }
        break
        case GET_STATE_FAILED :
        state = { 
          ...state, 
          statesBasedOnCountry: null ,
          loading: false
        }
        break
        case VALIDATE_URL :
          state = { 
            ...state, 
            isUrlValid: null ,
            isUrlValidFailed:null,
          }
          break
          case VALIDATE_URL_SUCCESS :
          state = { 
            ...state, 
            isUrlValid:action.payload ,
            isUrlValidFailed:null,
          }
          break
          case VALIDATE_URL_FAILED :
          state = { 
            ...state, 
            isUrlValid:null ,
            isUrlValidFailed:action.payload,
          }
          break

          case ACCOUNT_SWITCH :
            state = { 
              ...state, 
              loader:true,
              accountSwitchError : null,
              requestedUserType : action.payload
            }
          break
          case ACCOUNT_SWITCH_SUCCESS :
            state = { 
              ...state, 
              loader:false,
              grantedUserType : action.payload
            }
          break
          case ACCOUNT_SWITCH_FAILED :
            state = { 
              ...state, 
              loader:false,
              accountSwitchError : action.payload
            }
          break
          case ACCOUNT_SWITCH_CLEAR :
            state = { 
              ...state,
              accountSwitchError : null
            }
          break

    default:
      state = { ...state }
      break
  }
  return state
}

export default profile
